export function ColWidthSum(colWidth, numCols) {
  var colWSum = colWidth * numCols - (numCols - 1);
  return colWSum;
}
